import { connect } from "react-redux";

import {
  selectPrintablePages,
  selectTitle,
  selectNonPrintableMessageUseDefault,
  selectNonPrintableMessageAdditionalInfo,
  selectSize
} from "~/store/ducks/domain/config";
import { selectDisplayedPages } from "~/store/selectors/page";
import { setPage, goToDestination } from "~/store/middlewares/page";
import { selectIsAbleToPrint, selectRelativePage } from "~/store/ducks";
import { selectShowPrintButton } from "~/store/ducks/domain/ui/menu";

import PrintOptionsModal from "./PrintOptionsModal";

const mapStateToProps = state => ({
  activePages: selectDisplayedPages(state),
  printablePages: selectPrintablePages(state),
  getPage: selectRelativePage(state),
  showPrintButton: selectShowPrintButton(state),
  isAbleToPrint: selectIsAbleToPrint(state),
  useDefault: selectNonPrintableMessageUseDefault(state),
  additionalInfo: selectNonPrintableMessageAdditionalInfo(state),
  title: selectTitle(state),
  size: selectSize(state)
});

const mapDispatchToProps = {
  goToDestination,
  setPage
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintOptionsModal);
